import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hero-socios',
  templateUrl: './hero-socios.component.html',
  styleUrls: ['./hero-socios.component.scss']
})
export class HeroSociosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
